export const LOCAL_STORAGE = {
    BUILD_VERSION: 'buildVersion',
    LAST_DB: 'lastDb',
    LAST_LOGIN:'lastLogin',
    LANGUAGE: 'language',
    FILE_DIR: 'fileDir',
    HYPERLINK_SOURCE: 'hyperlinkSource',
    LOCK_DATE: 'lockDate'
};